class CollapsibleList extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    this.shadowRoot.innerHTML = `
        <style>
          [aria-expanded="true"] + ul {
            display: block;
          }
          [aria-expanded="false"] + ul {
            display: none;
          }
        </style>
        <div>
          <slot></slot>
        </div>
      `;
  }

  setupEventListeners() {
    const buttons = this.querySelectorAll('button');
    buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      const menu = button.nextElementSibling;
      if (menu && menu.tagName === 'UL') {
        menu.hidden = true;
      }

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true' || false;
        button.setAttribute('aria-expanded', !expanded);
        if (menu) {
          menu.hidden = !menu.hidden;
        }
      });
    });
  }
}

customElements.define('collapsible-list', CollapsibleList);
